





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import DepositCardSettingsEdit from '@/components/Products/Forms/Deposit/DepositCardSettingsEdit.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'DepositCardSettingsEditDialog', components: { DepositCardSettingsEdit } })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editDepositCardSettings();
            await ProductDetailsModule.getHistory();
        }
    }

}
